export const BUSINESS_ACCOUNT_REGISTER_URL = '/pro/register'
